import { partInfoHelper } from "@/components/mixins";
import CurrencyText from "@/components/Elements/CurrencyText.vue";
import LoadingSpinner        from "@/components/Elements/LoadingSpinner.vue";

export default {
  components: {
    CurrencyText,
    LoadingSpinner
  },
  props: {
    part: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  mixins: [partInfoHelper],
  methods: {},
}